import { useQuery } from "react-query";
import { fetchAccountTypes } from "../helpers/api";

const useAccountTypes = () => {
  return useQuery(["get-accounttypess"], fetchAccountTypes, {
    select: (data) => data,
  });
};

export { useAccountTypes };